import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../rootSelectors';
import RANView from './RANView';
import AvatarView from '../common/avatar/avatarView';
import withAvatar from '../common/avatar/withAvatar';
import { RAN } from '../constants/measure';
import { PRACTICE } from '../constants/assessmentItemType';
import { narrateStart, narrateReset, stopAudio } from '../common/audio/audioActions';
import {
    blockScreen,
    unblockScreen,
    unmountScreen,
    toggleCircleButtons,
} from '../common/screen/screenActions';
import { goToCountdown } from '../common/navigation/navigationActions';
import { getMeasureType } from '../common/utils/urlParsers';
import RAN_AUDIO_INSTRUCTIONS from './ranConstants';
import {
    fetchRANContent,
    playPracticeScript,
    onPracticeItemResponse,
    resetItemActiveIndex,
} from './ranActions';
import { getAvatarPosition } from '../common/alex/AlexUtils';

const mapStateToProps = (state, ownProps) => {
    const measureType = getMeasureType(ownProps.location.pathname);
    return {
        pageType: PRACTICE,
        measureType,
        pageLayout: `${RAN.MEASURE} ${measureType} ${PRACTICE}`,
        isDataFetched: selectors.getIsRANDataFetched(state, measureType),
        isScreenBlocked: selectors.getIsScreenBlocked(state),
        isScreenGreyedOut: selectors.getIsScreenGreyedOut(state),
        activeItemIndex: selectors.getRANActiveItemIndex(state),
        isNextButtonActive: selectors.getIsNextButtonActive(state),
        isCircleButtonsVisible: selectors.getIsCircleButtonsVisible(state),
        items: selectors.getRANItems(state, PRACTICE),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    const measureType = getMeasureType(ownProps.location.pathname);
    return {
        fetchContent: () => {
            dispatch(fetchRANContent(measureType));
        },
        narrateScreen: () => {
            dispatch(blockScreen());
            dispatch(narrateStart());
            dispatch(toggleCircleButtons());
            return dispatch(playPracticeScript(measureType)).then(() => {
                dispatch(narrateReset());
                dispatch(unblockScreen());
            });
        },
        onNextItem: () => dispatch(onPracticeItemResponse(measureType)),
        onNext: () => {
            dispatch(goToCountdown(RAN.MEASURE, measureType));
        },
        cleanup: () => {
            dispatch(stopAudio());
            dispatch(narrateReset());
            dispatch(resetItemActiveIndex());
            dispatch(unmountScreen());
        },
    };
};

const avatarMapStateToProps = (_, props) => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.LOWER_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
        instructions: RAN_AUDIO_INSTRUCTIONS[props.measureType].practiceInstructionStart,
    };
};

const RANPracticeContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(RANView);

export default RANPracticeContainer;
